import { ResolveFn } from '@angular/router';
import {Region} from "./region.model";
import {RegionService} from "./region.service";
import {inject} from "@angular/core";

export const regionResolver: ResolveFn<Region[]> = (route, state) => {
  const regionService: RegionService = inject(RegionService)
  return regionService.fetchAll()
};
